interface Price {
  amount: number;
  price_id?: null | string;
}

export interface Tier {
  name: string;
  type: 'service';
  prices: NodeJS.Dict<Price>;
  product_id?: string;
}

export const discountFactor = 0.7;

export const fullPrices = {
  service: {
    onecity: {
      usd: 530,
      eur: 500,
      cny: 0,
    },
    fivecities: {
      usd: 1070,
      eur: 1000,
      cny: 0,
    },
    tencities: {
      usd: 2140,
      eur: 2000,
      cny: 0,
    },
  },
} as any;

export const tiers: NodeJS.Dict<Tier[]> = {
  production: Object.keys(fullPrices.service).map((key) => ({
    name: key,
    type: 'service',
    product_id: `prod_${key}`,
    prices: {
      usd: {
        amount: fullPrices.service[key].usd,
        price_id: `price_${key}_usd`,
      },
      eur: {
        amount: fullPrices.service[key].eur,
        price_id: `price_${key}_eur`,
      },
      cny: {
        amount: fullPrices.service[key].cny,
        price_id: `price_${key}_cny`,
      },
    },
  })) as any,
  development: Object.keys(fullPrices.service).map((key) => ({
    name: key,
    type: 'service',
    product_id: `prod_${key}`,
    prices: {
      usd: {
        amount: fullPrices.service[key].usd,
        price_id: `price_${key}_usd`,
      },
      eur: {
        amount: fullPrices.service[key].eur,
        price_id: `price_${key}_eur`,
      },
      cny: {
        amount: fullPrices.service[key].cny,
        price_id: `price_${key}_cny`,
      },
    },
  })) as any,
};

const prices = {
  production: {
    service_provider: {
      service: {
        onecity: {
          usd: 'price_onecity_usd',
          eur: 'price_onecity_eur',
          cny: 'price_onecity_cny',
        },
        fivecities: {
          usd: 'price_fivecities_usd',
          eur: 'price_fivecities_eur',
          cny: 'price_fivecities_cny',
        },
        tencities: {
          usd: 'price_tencities_usd',
          eur: 'price_tencities_eur',
          cny: 'price_tencities_cny',
        },
      },
      twentycities: {
        usd: 'price_twentycities_usd',
        eur: 'price_twentycities_eur',
        cny: 'price_twentycities_cny',
      },
    },
    thirtycities: {
      usd: 'price_thirtycities_usd',
      eur: 'price_thirtycities_eur',
      cny: 'price_thirtycities_cny',
    },
  },
  development: {
    service_provider: {
      service: {
        onecity: {
          usd: 'price_onecity_usd',
          eur: 'price_onecity_eur',
          cny: 'price_onecity_cny',
        },
      },
      fivecities: {
        usd: 'price_fivecities_usd',
        eur: 'price_fivecities_eur',
        cny: 'price_fivecities_cny',
      },
    },
    tencities: {
      usd: 'price_tencities_usd',
      eur: 'price_tencities_eur',
      cny: 'price_tencities_cny',
    },

    twentycities: {
      usd: 'price_twentycities_usd',
      eur: 'price_twentycities_eur',
      cny: 'price_twentycities_cny',
    },
    thirtycities: {
      usd: 'price_thirtycities_usd',
      eur: 'price_thirtycities_eur',
      cny: 'price_thirtycities_cny',
    },
  },
} as any;

export default prices;
